import { render, staticRenderFns } from "./versionLine.vue?vue&type=template&id=8f98c670"
import script from "./versionLine.vue?vue&type=script&lang=js"
export * from "./versionLine.vue?vue&type=script&lang=js"
import style0 from "./versionLine.vue?vue&type=style&index=0&id=8f98c670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports